import { LocalizedDateFromUtc } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { lt } from '@mews/framework';
import { IconName, Tag } from '@optimus-web/core';
import { ReservationContractSignatureStatus } from '@mews-commander/data-access';
import { ExpirationDaysLeftText } from '../ExpirationDaysLeftText';

interface SignatureStatusCellProps {
    status?: ReservationContractSignatureStatus;
    signatureDate?: string;
    expirationDate?: string;
}

export const SignatureStatusCell = ({ status, signatureDate, expirationDate }: SignatureStatusCellProps) => {
    switch (status) {
        case ReservationContractSignatureStatus.Signed:
            return (
                <Tag variant="success" leadingIcon={IconName.Done}>
                    {lt('ContractSignatureStatusSignedLabel')}
                    {UnicodeEntity.NoBreakSpace}
                    {signatureDate != null && <LocalizedDateFromUtc utcString={signatureDate} />}
                </Tag>
            );
        case ReservationContractSignatureStatus.Pending:
            return (
                <Tag variant="warning" leadingIcon={IconName.Hourglass}>
                    {lt('ContractSignatureStatusPendingLabel')}
                    {UnicodeEntity.NoBreakSpace}
                    <ExpirationDaysLeftText expirationDate={expirationDate} />
                </Tag>
            );
        case ReservationContractSignatureStatus.NotSigned:
            return (
                <Tag variant="basicSubtle" leadingIcon={IconName.Disable}>
                    {lt('ContractSignatureStatusNotSignedLabel')}
                </Tag>
            );
        default:
            return null;
    }
};
